
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.875 14.25a.796.796 0 01-.13-.011 1.126 1.126 0 01-.983-.983.796.796 0 010-.261c.06-.513.47-.923.983-.983a.699.699 0 01.261-.001c.513.06.923.47.983.983a.817.817 0 010 .262c-.06.513-.47.923-.983.983a.817.817 0 01-.131.011zM4.125 14.25a.796.796 0 01-.13-.011 1.127 1.127 0 01-.983-.982.737.737 0 01-.001-.263c.06-.513.47-.922.983-.983a.817.817 0 01.261 0c.513.06.922.47.983.983a.717.717 0 01.001.262c-.06.513-.47.922-.983.983a.817.817 0 01-.131.011z"}}),_c('path',{attrs:{"d":"M21 20.25A2.252 2.252 0 0118.75 18v-.75H5.25V18c0 1.241-1.009 2.25-2.25 2.25S.75 19.241.75 18v-1.065A1.741 1.741 0 010 15.5v-3.75a2.755 2.755 0 012.51-2.74l1.506-3.357c.421-1.129 1.546-1.903 2.79-1.903h10.385c1.247 0 2.375.782 2.811 1.947l1.488 3.314A2.754 2.754 0 0124 11.75v3.75c0 .579-.282 1.11-.75 1.435V18A2.252 2.252 0 0121 20.25zM20.25 18a.75.75 0 001.5 0v-.75h-1.5V18zm-18 0a.75.75 0 001.5 0v-.75h-1.5V18zm.5-7.5c-.689 0-1.25.561-1.25 1.25v3.75c0 .138.112.25.25.25h20.5a.25.25 0 00.25-.25v-3.75c0-.689-.561-1.25-1.25-1.25H2.75zM19.842 9l-1.226-2.733c-.233-.617-.801-1.017-1.422-1.017H6.807c-.622 0-1.186.391-1.404.973L4.158 9h15.684z"}})])
          )
        }
      }
    